import React, { useState } from 'react';
import { Box } from '@mui/material';
import Services from '../Common/Services/page';
import { QUERY_KEYS_SIA } from '../../Common/hooks/useChartsData';
import { CityServicesWrapper } from '../../Common/Services/pages/CityServices';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer';

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return (
                <Services
                    module={{
                        title: 'Atendimentos - Faixa Etária',
                        className: 'services-container-dashboards',
                        sectionTitle: 'do Total de Atendimentos'
                    }}
                    queryConfig={{
                        key: QUERY_KEYS_SIA.AGE_GROUP,
                        url: 'governanceroom/dashboard/services/profile/age'
                    }}
                />
            );
        case 1:
            return (
                <Services
                    module={{
                        title: 'Atendimentos - Gênero',
                        className: 'services-container-dashboards',
                        sectionTitle: 'do Total de Atendimentos'
                    }}
                    queryConfig={{
                        key: QUERY_KEYS_SIA.GENDER,
                        url: 'governanceroom/dashboard/services/profile/gender'
                    }}
                />
            );
        case 2:
            return (
                <Services
                    module={{
                        title: 'Atendimentos - Raça/Cor',
                        className: 'services-container-dashboards',
                        sectionTitle: 'do Total de Atendimentos'
                    }}
                    queryConfig={{
                        key: QUERY_KEYS_SIA.RACE_COLOR,
                        url: 'governanceroom/dashboard/services/profile/ethnicity'
                    }}
                />
            );
        case 3:
            return (
                <CityServicesWrapper
                    queryConfig={{
                        key: QUERY_KEYS_SIA.CITY,
                        url: 'governanceroom/dashboard/services/profile/city'
                    }}
                />
            );
        default:
            return null;
    }
};

const titleMap = {
    [`0`]: 'Atendimentos - Faixa Etária',
    [`1`]: 'Atendimentos - Gênero',
    [`2`]: 'Atendimentos - Raça/Cor',
    [`3`]: 'Atendimentos - Município'
};

const Perfil = ({ setActiveIndex }) => {
    const [activeIndex, setActiveIndexLocal] = useState(0);

    const menus = [
        {
            title: 'Faixa Etária',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndex === 0
        },
        {
            title: 'Gênero',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndex === 1
        },
        {
            title: 'Raça/Cor',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndex === 2
        },
        {
            title: 'Município',
            onclick: () => setActiveIndexLocal(3),
            active: activeIndex === 3
        }
    ];

    return (
        <Box>
            <Header menus={menus} onHomeClick={() => setActiveIndex(0)} />
            <Box className="content">
                {' '}
                <ChartsContainer
                    title={titleMap[`${activeIndex}`]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndex)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Perfil;
